import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    data: [],
    loading: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const newData = [...state.data];

    switch (type) {

    case actions.TRAINERS_FETCHED:
        return { ...state, data: payload };

    case actions.TRAINER_CREATED:
        newData.push(payload);
        return { ...state, data: newData };

    case actions.TRAINER_DELETED:
        return { ...state, data: newData.filter(c => c.userId !== payload.userId) };

    case actions.TRAINERS_FETCH_LOADING:
        return { ...state, ...payload };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/trainers/trainers.reducer.js